import DateInput from '../inputs/DateInput';
import createField from './createField';

const DateField = createField(DateInput, { commitWarningOnChange: true });

export default DateField;
